import * as React from "react";
import { SVGProps } from "react";
function SvgHintIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333Zm0-1.333A5.333 5.333 0 1 0 8 2.667a5.333 5.333 0 0 0 0 10.667Zm.666-6v4H7.333v-4h1.333Zm0-1.333V4.667H7.333v1.334h1.333Z"
        fill="#16A085"
      />
    </svg>
  );
}
export default SvgHintIcon;
